//------------------------------------------------------------------------------
// Node Modules ----------------------------------------------------------------
import React from 'react';
import classNames from 'classnames';
//------------------------------------------------------------------------------
// Style -----------------------------------------------------------------------
import styles from './index.module.scss';
//------------------------------------------------------------------------------
// My Components ---------------------------------------------------------------
import { Button, Form, ButtonStyle } from '@cmp/common';
import { withTranslation } from 'react-i18next'; //------------------------------------------------------------------------------
// Helpers ---------------------------------------------------------------------
import { ScreenSet, showScreenSet, removeEmptyAddresses } from '@helpers/gigya';
import { handleGtmEvent } from '@helpers/gtm';
import { StoreConfigContext } from '@helpers/storeConfigContext';
import Landing from '../../index';
//------------------------------------------------------------------------------
// React Class -----------------------------------------------------------------
class CreateAccount extends React.Component {
  componentDidMount() {
    const {
      storeConfig: { language },
    } = this.context;
    showScreenSet(
      language,
      {
        ...ScreenSet.SignUp,
        events: {
          onAfterScreenLoad: (e) => {
            document
              .getElementById('signup-container')
              .querySelectorAll('.gigya-input-text,.gigya-input-password')
              .forEach((nodeInput) => {
                nodeInput.addEventListener('keyup', (event) => {
                  window.interactiveLabel(event);
                });
              });
            removeEmptyAddresses(e);
          },
        },
      },
      'signup-container',
      {}
    );
  }
  additionalComponent() {
    const { t } = this.props;
    return <div className={styles.AdditionalComponent}></div>;
  }
  render() {
    const { t } = this.props;
    const componentClasses = classNames(styles.CreateAccount);

    return (
      <div className={componentClasses}>
        <div className={styles.CreateAccountContent}>
          <div className={styles.Login}>
            <h2 className={styles.Title}>
              {t('landing_LogInToYourClinicAccount')}
            </h2>
            <h4 className={styles.SubTitle}>
              {t('landing_LogInToYourClinicAccountDesc')}
            </h4>
            <Form
              className={styles.Form}
              additionalComponent={this.additionalComponent()}
              id="login-container"
            />
          </div>

          <div className={styles.Divider} />

          <div className={styles.Register}>
            <h2 className={styles.Title}>{t('landing_CreateAccount')}</h2>
            <h2 className={styles.TitleMobile}>
              {t('landing_CreateAccountTodayMobile')}
            </h2>
            <h4 className={styles.SubTitle}>
              {t('landing_YoullRecommendProducts')}
            </h4>
            <Button className={styles.Button} to="/signup">
              {t('landing_Register')}
            </Button>
          </div>
        </div>
      </div>
    );
  }
}
//------------------------------------------------------------------------------
// Export ----------------------------------------------------------------------
export default withTranslation()(CreateAccount);
CreateAccount.contextType = StoreConfigContext;
